import React, { useEffect } from "react";
import { Button, Result } from "antd";
import { Link, useNavigate } from "react-router-dom";
const NoPage = () => {
  const navigate = useNavigate();
  const redirect = () => {
    navigate("/404", { replace: true });
  };
  useEffect(() => {
    redirect();
  }, []);
  return (
    <Result
      style={{ margin: "30px 0" }}
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Link
          to="/"
          title="Back Home"
          style={{ margin: "auto", display: "flex", width: "fit-content" }}
        >
          <Button type="primary">Back Home</Button>
        </Link>
      }
    />
  );
};

export default NoPage;
